module.exports = __webpack_public_path__ + "53490b9cbea1a2e42f1ea3cbc45425a0.jpg";